import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ToastHost } from 'src/views/common/Toast'

// import 'src/_mockApis'

// project imports
import * as serviceWorker from 'src/serviceWorker'
import App from 'src/App'
import { store, persister } from 'src/store'

// style + assets
import './assets/scss/style.scss'
import config from 'src/config'
// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.querySelector('#root')
const root = createRoot(container!)

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persister}>
            <BrowserRouter basename={config.basename}>
                <ToastHost />
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

